import React, { createContext, useCallback, useContext, useEffect, useMemo, useReducer } from "react";
import { AuthContext } from "./AuthContext";

export const [PAGE_LOGIN, PAGE_REGISTER, PAGE_ANNOUNCE, PAGE_OWN, PAGE_DATABASE, PAGE_ACCOUNT, PAGE_LOCK, PAGE_SUMMARY, PAGE_FAQ, PAGE_MAOLAM_REGISTER, PAGE_MAOLAM_APPROVE] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const PageContext = createContext({});

const initialState = {
    page : PAGE_LOGIN,
}



const reducer = (state, action) => {
    switch (action.type) {
        case "SET_PAGE":
            return {...state, page : action.payload}
        default:
            break;
    }
}

export const PageProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const { page } = state;
    const setPage = useCallback(payload => dispatch({ type: 'SET_PAGE', payload }), [])

    const { isLogin, userRole } = useContext(AuthContext)

    useEffect(() => {
        if (isLogin) {
            setPage(userRole ? PAGE_DATABASE : PAGE_OWN)
        }
        else {
            setPage(PAGE_LOGIN)
        }
    }, [isLogin, userRole, setPage])

    useEffect(() => {
        return () => {
            setPage(0)
        }
    }, [setPage])
    
    return (
        <PageContext.Provider value={useMemo(() => ({ page, setPage }), [page, setPage])}>
            {children}
        </PageContext.Provider>
    )
}